var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { display: "inline" },
      attrs: {
        id: _vm.id,
        "data-toggle": "tooltip",
        "data-placement": _vm.placement,
        "data-original-title": _vm.title,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }